import { C_Global_Error_Code } from '../../graphql/generatedModel';
import { LocalizationHelper } from '../helpers/localization/localization.helper';

type Keys =
  | C_Global_Error_Code
  | 'unknown'
  | 'unknownWithReload'
  | 'connectionLost'
  | 'requestTimedOut'
  | 'reload'
  | '404'
  | 'noPermissions'
  | 'toHome';

const t = LocalizationHelper<Keys>('errors');

export const errorsDe = t({
  unknown: 'Etwas ist schief gelaufen!',
  unknownWithReload: 'Etwas ist schiefgelaufen! Bitte versuchen Sie, die Seite neu zu laden.',
  connectionLost: 'Die Verbindung zum Server wurde unterbrochen. Bitte versuchen Sie es erneut.',
  reload: 'Neu laden',
  404: '404 Nicht gefunden',
  noPermissions: 'Sie haben keine Berechtigung, diese Seite anzusehen.',
  toHome: 'Gehen Sie zur Startseite',
  [C_Global_Error_Code.GEC10_INVALID_GQL_DATA]: 'Falsche Datenbankdaten',
  [C_Global_Error_Code.GEC11_INVALID_DATABASE_DATA]: 'Falsche Datenbankdaten',
  [C_Global_Error_Code.GEC20_NO_DATA]: 'Für Ihre Anfrage liegen keine Daten vor',
  [C_Global_Error_Code.GEC30_BAD_USER_INPUT]: 'Ungültige Daten an Server gesendet',
  [C_Global_Error_Code.GEC40_DELETING_RECORD_IN_USE]: 'Der gelöschte Datensatz wird verwendet',
  [C_Global_Error_Code.GEC41_DELETE_PROHIBITED]: 'Löschen verboten',
  [C_Global_Error_Code.GEC42_DEACTIVATING_BY_EMPTY_NAME_RECORD_IN_USE]:
    'Dieser Datensatz wird verwendet',
  [C_Global_Error_Code.GEC43_DEACTIVATING_BY_EMPTY_NAME_PROHIBITED]: 'Deaktivieren ist verboten',
  [C_Global_Error_Code.GEC50_DB_IS_IN_UPDATING_PROCCES]: 'Die Datenbank wird gerade aktualisiert',
  [C_Global_Error_Code.GEC53_COMPANY_DB_NOT_PROVISIONED]:
    'WaWiAssist ist für dieses Unternehmen nicht eingerichtet. Bitte wählen Sie ein anderes Unternehmen oder wenden Sie sich an den Support.',
  [C_Global_Error_Code.GEC51_EMPTY_HISTORY_USER_ID]: 'HistoryUserID Fehler',
  [C_Global_Error_Code.GEC52_ERROR_IN_STORED_PROCEDURE]: 'Server fehler',
  [C_Global_Error_Code.GEC60_BAKERY2B_USER_ALREADY_CONNECTED_TO_OTHER_COMPANY]:
    'Benutzer ist bereits mit einem anderen Unternehmen verbunden',
  [C_Global_Error_Code.GEC61_BAKERY2B_USER_ALREADY_CONNECTED_TO_THIS_COMPANY]:
    'Benutzer ist bereits mit diesem Unternehmen verbunden',
  [C_Global_Error_Code.GEC62_BAKERY2B_USER_IS_DEACTIVATED]: 'Bakery2B-Benutzer ist deaktiviert',
  [C_Global_Error_Code.GEC63_BAKERY2B_USER_ALREADY_LINKED_TO_THIS_CUSTOMER]:
    'Bakery2B-Benutzer ist bereits mit diesem Kunden verknüpft',
  [C_Global_Error_Code.GEC64_BAKERY2B_INVITE_API_ERROR]:
    'Fehler beim Einladen des Bakery2B-Benutzers (API-Fehler)',
  [C_Global_Error_Code.GEC65_BAKERY2B_USER_NOT_CONNECTED_TO_COMPANY]:
    'Bakery2B-Benutzer ist mit keinem Unternehmen verbunden',
  [C_Global_Error_Code.GEC66_BAKERY2B_USER_NOT_ACTIVE_MEMBER_OF_COMPANY]:
    'Bakery2B-Benutzer ist kein aktives Mitglied des verbundenen Unternehmens',
  [C_Global_Error_Code.GEC44_DELETE_USER_HAS_CUSTOMERS]:
    'Löschen nicht möglich: Der Client ist mit Kunden verbunden',
  [C_Global_Error_Code.GEC70_FORBIDDEN]: 'Zugriff verweigert. Sie haben keine Berechtigung.',
  [C_Global_Error_Code.GEC71_ORDER_DATE_LOCKED]: 'Shop ist für diesen Tag bereits geschlossen.',
  [C_Global_Error_Code.GEC72_MULTI_ORDER_NOT_ALLOWED]:
    'Für diesen Tag besteht bereits eine Bestellung. Mehrere Bestellungen pro Tag sind nicht erlaubt. Bitte bearbeiten Sie die bestehende Bestellung.',
  [C_Global_Error_Code.GEC73_ORDER_SAVE_FAILED]: 'Bestellung konnte nicht gespeichert werden',
  [C_Global_Error_Code.GEC74_DROPSHIP_CUSTOMER_NOT_LINKED]:
    'Der Kunde ist für Bestellungen bei diesem Lieferanten nicht korrekt verknüpft — die Kundennummer muss aus 4 Ziffern bestehen.',
  [C_Global_Error_Code.GEC75_DROPSHIP_ARTICLES_NOT_AVAILABLE]:
    'Die bestellten Artikel sind beim Lieferanten nicht verfügbar.',
  [C_Global_Error_Code.GEC76_DROPSHIP_ORDER_NUMBER_RANGE_FULL]:
    "Für diesen Kunden wurde die maximale Anzahl an Bestellungen (rund 99'999) erreicht. In WawiAssist muss ein neuer Kunde angelegt und mit dem Bakery2b-Konto verknüpft werden.",
  [C_Global_Error_Code.GEC77_DROPSHIP_ORDER_NOT_FOUND_IN_SUPPLIER]:
    'Diese Bestellung kann nicht mehr bearbeitet werden, da sie im Lieferantensystem nicht gefunden wurde. Bitte laden Sie die Seite neu.',
  [C_Global_Error_Code.GEC80_RESPONSE_TOO_LARGE]:
    'Das Ergebnis ist zu groß für die Übertragung. Bitte schränken Sie den Zeitraum oder die Filter ein.',
  requestTimedOut:
    'Der Server hat nicht rechtzeitig geantwortet. Der Vorgang wurde möglicherweise trotzdem ausgeführt - bitte prüfen Sie das Ergebnis, bevor Sie es erneut versuchen.',
});

export const errorsFr = t({
  unknown: 'Une erreur est survenue !',
  unknownWithReload: 'Une erreur est survenue ! Veuillez recharger la page.',
  connectionLost: 'La connexion au serveur a été perdue. Veuillez réessayer.',
  reload: 'Recharger',
  404: '404 Page non trouvée',
  noPermissions: 'Vous n’avez pas l’autorisation de consulter cette page.',
  toHome: "Aller à la page d'accueil",
  [C_Global_Error_Code.GEC10_INVALID_GQL_DATA]: 'Données de la base incorrectes',
  [C_Global_Error_Code.GEC11_INVALID_DATABASE_DATA]: 'Données de la base incorrectes',
  [C_Global_Error_Code.GEC20_NO_DATA]: 'Aucune donnée pour votre requête',
  [C_Global_Error_Code.GEC30_BAD_USER_INPUT]: 'Données invalides envoyées au serveur',
  [C_Global_Error_Code.GEC40_DELETING_RECORD_IN_USE]: "L'enregistrement supprimé est utilisé",
  [C_Global_Error_Code.GEC41_DELETE_PROHIBITED]: 'Suppression interdite',
  [C_Global_Error_Code.GEC42_DEACTIVATING_BY_EMPTY_NAME_RECORD_IN_USE]:
    'Cet enregistrement est utilisé',
  [C_Global_Error_Code.GEC43_DEACTIVATING_BY_EMPTY_NAME_PROHIBITED]:
    'La désactivation est interdite',
  [C_Global_Error_Code.GEC50_DB_IS_IN_UPDATING_PROCCES]:
    'La base de données est en cours de mise à jour',
  [C_Global_Error_Code.GEC53_COMPANY_DB_NOT_PROVISIONED]:
    "WaWiAssist n'est pas configuré pour cette entreprise. Veuillez choisir une autre entreprise ou contacter le support.",
  [C_Global_Error_Code.GEC51_EMPTY_HISTORY_USER_ID]: 'Erreur HistoryUserID',
  [C_Global_Error_Code.GEC52_ERROR_IN_STORED_PROCEDURE]: 'Erreur du serveur',
  [C_Global_Error_Code.GEC60_BAKERY2B_USER_ALREADY_CONNECTED_TO_OTHER_COMPANY]:
    "L'utilisateur est déjà connecté à une autre entreprise",
  [C_Global_Error_Code.GEC61_BAKERY2B_USER_ALREADY_CONNECTED_TO_THIS_COMPANY]:
    " L'utilisateur est déjà connecté à cette entreprise",
  [C_Global_Error_Code.GEC62_BAKERY2B_USER_IS_DEACTIVATED]: "L'utilisateur Bakery2B est désactivé",
  [C_Global_Error_Code.GEC63_BAKERY2B_USER_ALREADY_LINKED_TO_THIS_CUSTOMER]:
    "L'utilisateur Bakery2B est déjà lié à ce client",
  [C_Global_Error_Code.GEC64_BAKERY2B_INVITE_API_ERROR]:
    "Erreur lors de l'invitation de l'utilisateur Bakery2B (erreur API)",
  [C_Global_Error_Code.GEC65_BAKERY2B_USER_NOT_CONNECTED_TO_COMPANY]:
    "L'utilisateur Bakery2B n'est connecté à aucune entreprise",
  [C_Global_Error_Code.GEC66_BAKERY2B_USER_NOT_ACTIVE_MEMBER_OF_COMPANY]:
    "L'utilisateur Bakery2B n'est pas un membre actif de l'entreprise connectée",
  [C_Global_Error_Code.GEC44_DELETE_USER_HAS_CUSTOMERS]:
    'Suppression impossible: le client est lié à des clients',
  [C_Global_Error_Code.GEC70_FORBIDDEN]: 'Accès refusé. Vous n’avez pas l’autorisation.',
  [C_Global_Error_Code.GEC71_ORDER_DATE_LOCKED]: 'La plate-forme est déjà fermée pour ce jour.',
  [C_Global_Error_Code.GEC72_MULTI_ORDER_NOT_ALLOWED]:
    'Une commande existe déjà pour ce jour. Plusieurs commandes par jour ne sont pas autorisées. Veuillez modifier la commande existante.',
  [C_Global_Error_Code.GEC73_ORDER_SAVE_FAILED]: "Échec de l'enregistrement de la commande",
  [C_Global_Error_Code.GEC74_DROPSHIP_CUSTOMER_NOT_LINKED]:
    "Le client n'est pas correctement lié pour les commandes auprès de ce fournisseur — le numéro de client doit comporter 4 chiffres.",
  [C_Global_Error_Code.GEC75_DROPSHIP_ARTICLES_NOT_AVAILABLE]:
    'Les articles commandés ne sont pas disponibles auprès du fournisseur.',
  [C_Global_Error_Code.GEC76_DROPSHIP_ORDER_NUMBER_RANGE_FULL]:
    'Le nombre maximal de commandes (environ 99 999) a été atteint pour ce client. Un nouveau client doit être créé dans WawiAssist et associé au compte Bakery2b.',
  [C_Global_Error_Code.GEC77_DROPSHIP_ORDER_NOT_FOUND_IN_SUPPLIER]:
    'Cette commande ne peut plus être modifiée car elle est introuvable chez le fournisseur. Veuillez recharger la page.',
  [C_Global_Error_Code.GEC80_RESPONSE_TOO_LARGE]:
    'Le résultat est trop volumineux pour être transféré. Veuillez restreindre la période ou les filtres.',
  requestTimedOut:
    "Le serveur n'a pas répondu à temps. L'opération a peut-être tout de même été effectuée - veuillez vérifier le résultat avant de réessayer.",
});

export const errorsIt = t({
  unknown: 'Si è verificato un errore!',
  unknownWithReload: 'Si è verificato un errore! Per favore, prova a ricaricare la pagina.',
  connectionLost: 'La connessione al server è stata persa. Riprova.',
  reload: 'Ricarica',
  404: '404 Non trovato',
  noPermissions: 'Non hai i permessi per visualizzare questa pagina.',
  toHome: 'Vai alla homepage',
  [C_Global_Error_Code.GEC10_INVALID_GQL_DATA]: 'Dati del database non corretti',
  [C_Global_Error_Code.GEC11_INVALID_DATABASE_DATA]: 'Dati del database non corretti',
  [C_Global_Error_Code.GEC20_NO_DATA]: 'Non ci sono dati per la tua richiesta',
  [C_Global_Error_Code.GEC30_BAD_USER_INPUT]: 'Dati non validi inviati al server',
  [C_Global_Error_Code.GEC40_DELETING_RECORD_IN_USE]: 'Il record eliminato è in uso',
  [C_Global_Error_Code.GEC41_DELETE_PROHIBITED]: 'Eliminazione proibita',
  [C_Global_Error_Code.GEC42_DEACTIVATING_BY_EMPTY_NAME_RECORD_IN_USE]: 'Questo record è in uso',
  [C_Global_Error_Code.GEC43_DEACTIVATING_BY_EMPTY_NAME_PROHIBITED]: 'Disattivazione proibita',
  [C_Global_Error_Code.GEC50_DB_IS_IN_UPDATING_PROCCES]: 'Il database è in fase di aggiornamento',
  [C_Global_Error_Code.GEC53_COMPANY_DB_NOT_PROVISIONED]:
    "WaWiAssist non è configurato per questa azienda. Selezionare un'altra azienda o contattare il supporto.",
  [C_Global_Error_Code.GEC51_EMPTY_HISTORY_USER_ID]: 'Errore HistoryUserID',
  [C_Global_Error_Code.GEC52_ERROR_IN_STORED_PROCEDURE]: 'Errore del server',
  [C_Global_Error_Code.GEC60_BAKERY2B_USER_ALREADY_CONNECTED_TO_OTHER_COMPANY]:
    "L'utente è già connesso a un'altra azienda",
  [C_Global_Error_Code.GEC61_BAKERY2B_USER_ALREADY_CONNECTED_TO_THIS_COMPANY]:
    "L'utente è già connesso a questa azienda",
  [C_Global_Error_Code.GEC62_BAKERY2B_USER_IS_DEACTIVATED]: "L'utente Bakery2B è disattivato",
  [C_Global_Error_Code.GEC63_BAKERY2B_USER_ALREADY_LINKED_TO_THIS_CUSTOMER]:
    "L'utente Bakery2B è già collegato a questo cliente",
  [C_Global_Error_Code.GEC64_BAKERY2B_INVITE_API_ERROR]:
    "Errore nell'invito dell'utente Bakery2B (errore API)",
  [C_Global_Error_Code.GEC65_BAKERY2B_USER_NOT_CONNECTED_TO_COMPANY]:
    "L'utente Bakery2B non è collegato a nessuna azienda",
  [C_Global_Error_Code.GEC66_BAKERY2B_USER_NOT_ACTIVE_MEMBER_OF_COMPANY]:
    "L'utente Bakery2B non è un membro attivo dell'azienda collegata",
  [C_Global_Error_Code.GEC44_DELETE_USER_HAS_CUSTOMERS]:
    'Impossibile eliminare: il cliente ha clienti collegati',
  [C_Global_Error_Code.GEC70_FORBIDDEN]: "Accesso negato. Non hai l'autorizzazione.",
  [C_Global_Error_Code.GEC71_ORDER_DATE_LOCKED]: 'Lo shop è già chiuso per questo giorno.',
  [C_Global_Error_Code.GEC72_MULTI_ORDER_NOT_ALLOWED]:
    "Esiste già un ordine per questo giorno. Non sono consentiti più ordini al giorno. Si prega di modificare l'ordine esistente.",
  [C_Global_Error_Code.GEC73_ORDER_SAVE_FAILED]: "Salvataggio dell'ordine non riuscito",
  [C_Global_Error_Code.GEC74_DROPSHIP_CUSTOMER_NOT_LINKED]:
    'Il cliente non è collegato correttamente per gli ordini presso questo fornitore — il numero cliente deve essere composto da 4 cifre.',
  [C_Global_Error_Code.GEC75_DROPSHIP_ARTICLES_NOT_AVAILABLE]:
    'Gli articoli ordinati non sono disponibili presso il fornitore.',
  [C_Global_Error_Code.GEC76_DROPSHIP_ORDER_NUMBER_RANGE_FULL]:
    "È stato raggiunto il numero massimo di ordini (circa 99'999) per questo cliente. In WawiAssist è necessario creare un nuovo cliente e collegarlo all'account Bakery2b.",
  [C_Global_Error_Code.GEC77_DROPSHIP_ORDER_NOT_FOUND_IN_SUPPLIER]:
    'Questo ordine non può più essere modificato perché non è stato trovato nel sistema del fornitore. Si prega di ricaricare la pagina.',
  [C_Global_Error_Code.GEC80_RESPONSE_TOO_LARGE]:
    'Il risultato è troppo grande per essere trasferito. Si prega di restringere il periodo o i filtri.',
  requestTimedOut:
    "Il server non ha risposto in tempo. L'operazione potrebbe comunque essere stata eseguita - verificare il risultato prima di riprovare.",
});

export const errorsEn = t({
  unknown: 'Something went wrong!',
  unknownWithReload: 'Something went wrong! Please try reloading the page.',
  connectionLost: 'The connection to the server was lost. Please try again.',
  reload: 'Reload',
  404: '404 Not found',
  noPermissions: 'You do not have permission to view this page.',
  toHome: 'Go to homepage',
  [C_Global_Error_Code.GEC10_INVALID_GQL_DATA]: 'Incorrect database data',
  [C_Global_Error_Code.GEC11_INVALID_DATABASE_DATA]: 'Incorrect database data',
  [C_Global_Error_Code.GEC20_NO_DATA]: 'There is no data for your request',
  [C_Global_Error_Code.GEC30_BAD_USER_INPUT]: 'Invalid data sent to server',
  [C_Global_Error_Code.GEC40_DELETING_RECORD_IN_USE]: 'Deleted record is used',
  [C_Global_Error_Code.GEC41_DELETE_PROHIBITED]: 'Delete prohibited',
  [C_Global_Error_Code.GEC42_DEACTIVATING_BY_EMPTY_NAME_RECORD_IN_USE]: 'This record is in use',
  [C_Global_Error_Code.GEC43_DEACTIVATING_BY_EMPTY_NAME_PROHIBITED]:
    'Deactivating is prohibitedDeaktivieren ist verboten',
  [C_Global_Error_Code.GEC50_DB_IS_IN_UPDATING_PROCCES]: 'Database is in updating process',
  [C_Global_Error_Code.GEC53_COMPANY_DB_NOT_PROVISIONED]:
    'WaWiAssist is not set up for this company. Please choose another company or contact support.',
  [C_Global_Error_Code.GEC51_EMPTY_HISTORY_USER_ID]: 'HistoryUserID error',
  [C_Global_Error_Code.GEC52_ERROR_IN_STORED_PROCEDURE]: 'Server error',
  [C_Global_Error_Code.GEC60_BAKERY2B_USER_ALREADY_CONNECTED_TO_OTHER_COMPANY]:
    'User already connected to other company',
  [C_Global_Error_Code.GEC61_BAKERY2B_USER_ALREADY_CONNECTED_TO_THIS_COMPANY]:
    'User already connected to this company',
  [C_Global_Error_Code.GEC62_BAKERY2B_USER_IS_DEACTIVATED]: 'Bakery2B user is deactivated',
  [C_Global_Error_Code.GEC63_BAKERY2B_USER_ALREADY_LINKED_TO_THIS_CUSTOMER]:
    'Bakery2B user is already linked to this customer',
  [C_Global_Error_Code.GEC64_BAKERY2B_INVITE_API_ERROR]: 'Error inviting Bakery2B user (API error)',
  [C_Global_Error_Code.GEC65_BAKERY2B_USER_NOT_CONNECTED_TO_COMPANY]:
    'Bakery2B user is not connected to any company',
  [C_Global_Error_Code.GEC66_BAKERY2B_USER_NOT_ACTIVE_MEMBER_OF_COMPANY]:
    'Bakery2B user is not an active member of the connected company',
  [C_Global_Error_Code.GEC44_DELETE_USER_HAS_CUSTOMERS]:
    'Cannot delete: client has connected customers',
  [C_Global_Error_Code.GEC70_FORBIDDEN]: 'Access denied. You do not have permission.',
  [C_Global_Error_Code.GEC71_ORDER_DATE_LOCKED]: 'Shop is already closed for this day.',
  [C_Global_Error_Code.GEC72_MULTI_ORDER_NOT_ALLOWED]:
    'An order for this day already exists. Multiple orders per day are not allowed. Please edit the existing order.',
  [C_Global_Error_Code.GEC73_ORDER_SAVE_FAILED]: 'Order save failed',
  [C_Global_Error_Code.GEC74_DROPSHIP_CUSTOMER_NOT_LINKED]:
    'The customer is not correctly linked for orders with this supplier — the customer number must contain 4 digits.',
  [C_Global_Error_Code.GEC75_DROPSHIP_ARTICLES_NOT_AVAILABLE]:
    'The ordered articles are not available from the supplier.',
  [C_Global_Error_Code.GEC76_DROPSHIP_ORDER_NUMBER_RANGE_FULL]:
    'The maximum number of orders (around 99,999) has been reached for this customer. A new customer needs to be created in WawiAssist and linked to the Bakery2b account.',
  [C_Global_Error_Code.GEC77_DROPSHIP_ORDER_NOT_FOUND_IN_SUPPLIER]:
    'This order can no longer be edited because it was not found in the supplier system. Please reload the page.',
  [C_Global_Error_Code.GEC80_RESPONSE_TOO_LARGE]:
    'The result is too large to transfer. Please narrow the date range or the filters.',
  requestTimedOut:
    'The server did not answer in time. The operation may still have been carried out - please check the result before trying again.',
});
